﻿
const countdownSeconds = 60;
const countdownText = 'S';
let intervalRef = null;
let originalText = 'Send';
export function countdownButton(button: HTMLButtonElement) {
    originalText = button.innerHTML;
    let current = countdownSeconds;
    button.innerText = `${current} ${countdownText}`;
    button.disabled = true;
    intervalRef = setInterval(() => {
        current--;
        button.innerText = `${current} ${countdownText}`;
        if (current === 0) {
            clearInterval(intervalRef);
            button.innerText = originalText;
            button.disabled = false;
        }
    }, 1000);
}